import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateDeclaracionJuradaGarantiasLaborales = () => {
  const [loadingCreateDeclaracionJuradaGarantiasLaborales, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateDeclaracionJuradaGarantiasLaborales, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateDeclaracionJuradaGarantiasLaborales, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateDeclaracionJuradaGarantiasLaborales, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createDeclaracionJuradaGarantiasLaborales = async (userId:string , data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudDeclaracionJuradaGarantias(userId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createDeclaracionJuradaGarantiasLaborales,
    loadingCreateDeclaracionJuradaGarantiasLaborales,
    successCreateDeclaracionJuradaGarantiasLaborales,
    errorCreateDeclaracionJuradaGarantiasLaborales,
    dataCreateDeclaracionJuradaGarantiasLaborales
  }

}

export default useCreateDeclaracionJuradaGarantiasLaborales;
